'use client';

import { CheckIcon } from '@phosphor-icons/react';
import { useDispatch, useSelector } from 'react-redux';
import { setTestFilter } from '../../../../../apps/frontend/src/redux/slices/packSlice';
import { useLocation, useNavigate } from 'react-router-dom'; // Import useLocation and useNavigate
import { useEffect } from 'react';

const TAB_FILTERS = [
  { id: 5, name: 'All Tests', value: 'all' },
  { id: 2, name: 'Last 3 Tests', value: 'last3' },
  { id: 3, name: 'Last 5 Tests', value: 'last5' },
  { id: 4, name: 'Last 10 Tests', value: 'last10' },
];

const TestFilterTabs = () => {
  const dispatch = useDispatch();
  const activeFilter = useSelector((state) => state.pack.filters?.testFilter || 'all');
  const location = useLocation();
  const navigate = useNavigate();

  // useEffect to handle URL parameters and set Redux state on load/URL change
  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const testCount = queryParams.get('test-count');

    if (testCount) {
      const filterValue = `last${testCount}`;
      // Dispatch the action only if the URL filter is different from the current active filter
      if (filterValue !== activeFilter) {
        dispatch(setTestFilter(filterValue));
      }
    } else if (activeFilter !== 'all') {
      // If no test-count is in the URL, ensure the filter defaults to 'all'
      dispatch(setTestFilter('all'));
    }
  }, [location.search, dispatch, activeFilter]);

  // New function to handle button clicks and update the URL
  const handleFilterClick = (filterValue) => {
    const searchParams = new URLSearchParams(location.search);
    if (filterValue === 'all') {
      searchParams.delete('test-count');
    } else {
      // Extract the number from the filterValue (e.g., 'last3' -> '3')
      const testCount = filterValue.replace('last', '');
      searchParams.set('test-count', testCount);
    }

    // Navigate to the new URL with the updated search parameters
    navigate(`${location.pathname}?${searchParams.toString()}`, { replace: true });
  };

  return (
    <div className="w-full overflow-x-auto mb-6">
      <div className="flex gap-2 whitespace-nowrap px-1">
        {TAB_FILTERS.map((filter) => (
          <button
            key={filter.id}
            onClick={() => handleFilterClick(filter.value)}
            disabled={filter.value === activeFilter}
            className={`px-4 py-2 rounded-full text-sm font-medium transition-colors flex items-center gap-2 flex-shrink-0 cursor-pointer ${
              activeFilter === filter.value
                ? 'bg-[var(--q3-accent-normal)] text-white'
                : 'bg-[var(--q3-surface-glass-normal)] text-[var(--q3-neutral-default)] hover:bg-[var(--q3-primary-light)] border border-[var(--q3-stroke-normal)]'
            }`}
          >
            {filter.name}
            {activeFilter === filter.value && <CheckIcon size={16} weight="bold" />}
          </button>
        ))}
      </div>
    </div>
  );
};

export default TestFilterTabs;
